(function () {
	Vue.component('nominow-tableresults', {
		template: `
    <div class="nominow-tableresults" :class="{' is-indented ': isIndented}">
    <div class="tile is-ancestor">
    <div class="tile is-parent">
    <div class="tile is-child">
    <div class="table-results" :class="{'is-full-table' : pagination.pagesize < items.length - 1}">
    <table class="table is-striped is-fullwidth " :class="{' is-selectable is-hoverable ': isSelectable, ' is-hoverable ' : isHoverable, ' is-logoutput ' : isLogoutput}">
    <thead class="css-show-invisible-on-hover is-clickable">
    <tr>
    <th v-for="(first,prop) in header" :style="'min-width:' + first + 'px;display:' + (first  == 0 ? 'none' :'auto')" :translate-key="'tableheader-' + prop" v-on:click="sortTable(prop)">
    <span>{{prop}}</span>
    <a class="is-link is-invisible is-pulled-right" :class="{'is-active is-visible': sortBy == prop}">
    <span class="icon is-small">
    <i class="fa fa-sort" aria-hidden="true" :class="{'fa-sort-up': sortBy == prop && sorting[prop], 'fa-sort-down': sortBy == prop && !sorting[prop]}"></i>
    </span>
    </a>
    </th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(result, i) in results" v-on:click="selectItem(result,i)" :class="getClass(result, i)">
    <td v-for="(first,prop) in header" :style="'min-width:' + first + 'px;display:' + (first  == 0 ? 'none' :'auto')" v-html="filter(result[prop])"></td>
    </tr>
    </tbody>
    </table>
    </div>
    </div>
    </div>
    </div>
    <div class="tile is-ancestor" v-if="pagination.pagesize < items.length - 1 || hasPageSizeSelect">
    <div class="tile is-parent">
    <div class="tile is-child">
    <div class="tile">
    <div>
    <select v-if="hasPageSizeSelect" v-model="pagination.pagesize">
    <option value="10">10</option>
    <option value="20">20</option>
    <option value="50">50</option>
    <option value="100">100</option>
    </select>
    </div>
    <nominow-pagination :pagination="pagination" v-if="pagination.pagesize < items.length - 1"></nominow-pagination>
    </div>
    </div>
    </div>
    </div>
    </div>
    `,
		created: function () { },
		props: {
			items: {
				type: Array,
				required: true,
				default: () => []
			},
			pagination: {
				type: Object,
				required: true,
				default: () => ({
					pagesize: Number,
					max: Number,
					currentpage: Number
				})
			},
			data: {
				type: Number,
				required: false
			},
			isSelectable: {
				type: Boolean,
				required: false
			},
			isHoverable: {
				type: Boolean,
				required: false
			},
			isLogoutput: {
				type: Boolean,
				required: false
			},
			hasPageSizeSelect: {
				type: Boolean,
				required: false
			},
			isIndented: {
				type: Boolean,
				required: false
			},
			rowClassFunction: {
				type: Function,
				required: false
			},
			searchword: {
				type: String,
				required: false
			}
		},
		watch: {
			items: function (newVal) {
				if (newVal != null) {
					const clone = window.cloneObject(newVal);
					this.header = clone[0];
					clone.splice(0, 1);
					if (!this.pagination.pagesize) {
						this.results = clone;
					} else {
						this.pagination.max = Math.floor(
							(clone.length - 1) / this.pagination.pagesize
						);
						// todo if print show all
						const pageSize = parseInt(this.pagination.pagesize);
						this.pagination.max = Math.floor(
							(clone.length - 1) / pageSize
						);
						const startindex =
							this.pagination.currentpage * pageSize;
						this.results = clone.slice(
							startindex,
							startindex + pageSize
						);
					}
				}
			},
			pagination: {
				handler: function (after, before) {
					this.setPage(after.currentpage);
				},
				deep: true
			}
		},
		data: function () {
			if (this.items != null && this.items.length > 0) {
				const clone = window.cloneObject(this.items);
				this.header = clone[0];
				clone.splice(0, 1);
				if (!this.pagination.pagesize) {
					this.results = clone;
				} else {
					this.setPage(this.pagination.currentpage);
				}
			}
			return {
				header: this.header == null ? {} : this.header,
				results: this.results == null ? [] : this.results,
				sorting: [],
				selected: null,
				sortBy: null
			};
		},
		methods: {
			filter: function (string) {
				if (
					this.searchword == undefined ||
					this.searchword.length == 0 ||
					string == undefined ||
					string.toLowerCase().indexOf(this.searchword) == -1
				) {
					return string;
				}

				const s = string.toLowerCase();
				const w = this.searchword.toLowerCase();
				const arr = s.split(w);

				if (arr[0] != '') {
					var prewordlowercase = arr[0];
					const start = string.substring(0, prewordlowercase.length);
					var word = string.substring(
						start.length,
						start.length + this.searchword.length
					);
					var end = string.substring(
						start.length + this.searchword.length
					);
					var final = `${start}<span class="has-text-weight-black has-text-info">${word}</span>${end}`;
					return final;
				}
				if (arr[0] == '') {
					var prewordlowercase = arr[1];
					var word = string.substring(0, this.searchword.length);
					var end = string.substring(this.searchword.length);
					var final = `<span class="has-text-weight-black has-text-info">${word}</span>${end}`;
					return final;
				}
				return string;
			},
			selectItem: function (item, index) {
				this.$emit('selectitem', item, index, this.data);
				this.selected = index;
			},
			getClass: function (item, index) {
				const classes = [];
				if (typeof this.rowClassFunction === 'function') {
					classes.push(this.rowClassFunction(item, index));
				}
				if (this.selected == index) {
					classes.push('is-selected');
				}
				return classes.length == 0 ? null : classes.join(' ');
			},
			setPage: function (page) {
				const clone = window.cloneObject(this.items);
				clone.splice(0, 1);
				const pageSize = parseInt(this.pagination.pagesize);
				this.pagination.max = Math.floor((clone.length - 1) / pageSize);
				const startindex = this.pagination.currentpage * pageSize;
				this.results = clone.slice(startindex, startindex + pageSize);
			},
			sortTable: function (prop) {
				const sortProp = prop;
				this.sortBy = sortProp;
				const array = this.items;
				// remove header
				array.splice(0, 1);
				// check for reverse
				const reverse = this.sorting[sortProp] == true;
				this.sorting[sortProp] = !reverse;

				// sort
				Array.prototype.sort.call(array, (a, b) => {
					let result = 0;
					if (a[sortProp] == null && b[sortProp] == null) {
						result = 0;
					} else if (a[sortProp] == null && b[sortProp] != null) {
						result = -1;
					} else if (b[sortProp] == null && a[sortProp] != null) {
						result = 1;
					} else if (sortProp.toLowerCase().indexOf('date') > -1) {
						const adate = new Date(a[sortProp]);
						const bdate = new Date(b[sortProp]);
						if (adate < bdate) {
							result = -1;
						} else {
							result = 1;
						}
					} else if (
						/^([€%]? )?\-?[\d\.]+$/.test(a[sortProp]) &&
						/^([€%]? )?\-?[\d\.]+$/.test(b[sortProp])
					) {
						const aint = parseFloat(
							`${a[sortProp]}`.replace('€', '').replace('%', '')
						);
						const bint = parseFloat(
							`${b[sortProp]}`.replace('€', '').replace('%', '')
						);
						if (aint < bint) {
							result = -1;
						} else {
							result = 1;
						}
					} else if (
						`${a[sortProp]}`.toUpperCase() <
						`${b[sortProp]}`.toUpperCase()
					) {
						result = -1;
					} else if (
						`${a[sortProp]}`.toUpperCase() >
						`${b[sortProp]}`.toUpperCase()
					) {
						result = 1;
					} else {
						result = 0;
					}
					return result * (reverse ? -1 : 1);
				});
				// readd header
				array.splice(0, 0, this.header);
				this.items = [];
				this.items = array;
				this.pagination.currentpage = 0;
			}
		}
	});
})();
